import React from 'react';
import './box.styles.scss';
import arrowDown from 'assets/svg/arrow-down.svg';

type BoxProps = {
    hiddenContent?: JSX.Element,
    className?: string,
    initialClosed?: boolean,
};

const Box: React.FC<BoxProps> = ({ hiddenContent, className = '', initialClosed = true,  children }): JSX.Element => {
    const [closed, toggle] = React.useState(initialClosed);

    return (
        <div className={`c-box ${className}`.trim()}>
            <div className="c-box__content">
                {children}
                <div className={`c-box__content--hidden ${closed ? 'closed' : ''}`.trim()}>
                    {hiddenContent}
                </div>
            </div>
            {hiddenContent && (
                <button
                    type="button"
                    className="c-box__accordion"
                    onClick={() => toggle(!closed)}
                >
                    <img
                        src={arrowDown}
                        className={`arrow ${!closed ? 'up' : ''}`.trim()}
                    />
                </button>
            )}
        </div>
    );
};

export default Box;
